import Icon from "@lib/common/components/Icon/Icon";
import { notifications as mantineNotifications } from "@mantine/notifications";
import type { ReactElement } from "react";

export abstract class notifications {
  private static errorColor: string = "red";
  private static errorIcon: ReactElement = (<Icon name="xmark" />);
  public static error(title: string, message?: string): void {
    mantineNotifications.show({
      title,
      message,
      color: this.errorColor,
      icon: this.errorIcon,
      autoClose: false
    });
  }

  private static warningColor: string = "orange";
  private static warningIcon: ReactElement = (<Icon name="exclamation" />);
  public static warning(title: string, message?: string): void {
    mantineNotifications.show({
      title,
      message,
      color: this.warningColor,
      icon: this.warningIcon,
      autoClose: false
    });
  }

  private static successColor: string = "green";
  private static successIcon: ReactElement = (<Icon name="check" />);
  public static success(title: string, message?: string): void {
    mantineNotifications.show({
      title,
      message,
      color: this.successColor,
      icon: this.successIcon,
      autoClose: true
    });
  }
}
